import { render, staticRenderFns } from "./bonuses.vue?vue&type=template&id=420cbd7a&scoped=true"
import script from "./bonuses.vue?vue&type=script&lang=js"
export * from "./bonuses.vue?vue&type=script&lang=js"
import style0 from "./bonuses.vue?vue&type=style&index=0&id=420cbd7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420cbd7a",
  null
  
)

export default component.exports